import {
  ApiError,
  BadRequestError,
  NetworkError,
  NotFoundError,
  UnauthorizedError,
  UnhandledError,
  ValidationError,
} from "@/lib/types/https-error.interface";

export type ApiErrorHandler = (errorData: ApiError) => void;

export const badRequestErrorStrategy: ApiErrorHandler = (errorData) => {
  throw {
    ...errorData,
  } as BadRequestError;
};

export const validationErrorStrategy: ApiErrorHandler = (errorData) => {
  throw {
    ...errorData,
  } as ValidationError;
};

export const notFoundErrorStrategy: ApiErrorHandler = (errorData) => {
  throw {
    ...errorData,
    code: 404,
    message: "سرویس مورد نظر پیدا نشد",
  } as NotFoundError;
};

export const unauthorizedErrorStrategy: ApiErrorHandler = (errorData) => {
  throw {
    ...errorData,
    message: "لطفا با حساب کاربری خود وارد شوید ",
  } as UnauthorizedError;
};

export const unhandledErrorStrategy: ApiErrorHandler = (errorData) => {
  throw {
    ...errorData,
    message: "مشکلی رخ داده است، لطفا با پشتیبانی تماس بگیرید",
  } as UnhandledError;
};

export const BannedErrorStrategy: ApiErrorHandler = (errorData) => {
  throw {
    ...errorData,
    message: "حساب کاربری شما مسدود شده است.",
  } as UnhandledError;
};

export const networkErrorStrategy = () => {
  throw {
    message: "خطای شبکه ",
  } as NetworkError;
};

export const defaultErrorStrategy: ApiErrorHandler = (errorData) => {
  throw {
    ...errorData,
    message: errorData?.message ? errorData.message : "مشکلی رخ داده است",
  } as BadRequestError;
};

export const errorHandler: Record<number, ApiErrorHandler> = {
  400: (errorData) => {
    if (errorData.errors) {
      return validationErrorStrategy(errorData);
    }
    return badRequestErrorStrategy(errorData);
  },
  401: unauthorizedErrorStrategy,
  404: notFoundErrorStrategy,
  405: badRequestErrorStrategy,
  409: (errorData) => {
    if (errorData.errors) {
      return validationErrorStrategy(errorData);
    }
    return badRequestErrorStrategy(errorData);
  },
  422: badRequestErrorStrategy,
  500: unhandledErrorStrategy,
};

export function handleError(status: number, errorData: ApiError) {
  const strategy = errorHandler[status] ?? defaultErrorStrategy;
  return strategy(errorData);
}
